import * as TK from 'components/post/GivingLinkDialog/translations/constants';
import { Translations } from 'translations/types';

export const givingLinkDialogEnUsLocale: Translations = {
  [TK.GIVING_LINK_DIALOG_BUTTON_LABEL]: 'Give',
  [TK.GIVING_LINK_DIALOG_MESSAGE]: 'Thank you for supporting! Click below to be taken to our external giving page.',
};
